const DomeCameraIcon = ({ strokeColor = "#808080" }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" fill="#4d4d4d" cx="397.55" cy="397.55" r="388.66"/>
        <circle 
          id="Grey" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="372.55"
        />
        <circle 
          id="White_Inner" 
          data-name="White Inner" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="343.4"
        />
      </g>
      <g id="Shapes">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <path 
            fill="#fbfbfb" 
            d="M586.3,464.01c-28.03,75.98-80.09,123.94-159.92,137.77-56.23,9.74-106.74-6.19-150.77-42.32-38.74-31.79-62.99-72.53-71.73-121.73-3.48-19.56-3.3-39.77-4.82-60.04-19.77-3.63-33.07-19.41-33.32-41.67-.22-19.28-.08-38.58.21-57.86.32-21.52,11.25-31.66,32.93-31.65,132.54.07,265.08.08,397.62.01,21.89-.01,32.77,10.2,32.89,31.79.1,18.74.13,37.48,0,56.21-.17,23.24-10.89,37.3-33.62,43.75.49,28.61-.3,57.34-9.46,85.74M603.82,311.74c0-10.47-.4-20.96.14-31.4.39-7.33-2.14-9.31-9.39-9.27-52.61.29-105.22.16-157.84.16-78.78,0-157.56.02-236.34-.05-5.08,0-9.25-.12-9.16,7,.24,19.83-.14,39.67.1,59.49.12,10.25,6.41,15.84,16.71,15.84,34.98,0,69.97-.02,104.95-.01,91.18,0,182.35.03,273.53.02,11.69,0,17.23-5.46,17.32-17,.06-7.71,0-15.43-.02-24.79M437.17,377.06h-210.29c-12.87,63.37,32.04,157.28,84.44,177.92,0-18.66-.29-37.37.12-56.05.2-9.29.75-18.76,2.73-27.8,8.44-38.6,39.69-66.39,78.87-68.78,34.18-2.08,69.19,15.2,85.29,54.57,6.07,14.86,6.98,30.35,7.42,45.92.48,16.94.11,33.91.11,51.32,62.86-32.05,92.68-117.43,84.3-177.09h-132.97M452.37,570.73c2.8-.86,5.61-1.71,8.67-2.65v-7.81c-.02-24.24.78-48.52-.26-72.72-1.55-35.88-26.53-59.49-61.76-59.99-31.21-.44-59.21,21.38-61.29,51.3-2.06,29.57-.45,59.4-.45,89.38,37.89,14.39,75.71,14.01,115.1,2.48h0Z"
          />
          <path 
            fill="#fcfcfc" 
            d="M377.51,503.32c-6.17-12.74-5.03-23.12,3.04-31.55,6.51-6.79,17.57-9.23,26.37-5.81,10.73,4.17,16.44,12.92,16.23,24.88-.19,10.41-6.49,18.72-17.1,22.54-9.93,3.58-20.39.03-28.55-10.07Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default DomeCameraIcon;